export default __webpack_public_path__ + "static/media/helpAddTrans.915a4753.png";